module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ivoice"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ivoice_banner"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_banner')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_banner_content')) + "\n        ")]), _vm._v(" "), _c('img', {
    staticClass: "ivoice_global",
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_global.png"),
      "width": "90%"
    }
  }), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ivoice_one"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ivoice_two1"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('ivoice_part1_tittle')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('ivoice_part1_content'))), _c('br'), _vm._v(_vm._s(_vm.$t('ivoice_part1_content1')))]), _vm._v(" "), _vm._m(1, false, false)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ivoice_two"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_part2_tittle')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_part2_content')) + "\n        ")]), _vm._v(" "), (this.ivoiceLang == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_banner3_en.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_banner3@2x.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ivoice_three"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_part3_tittle')) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ivoice_part3_content')) + "\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_earth@2x.jpg"),
      "width": "90%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ivoice_four"
  }, [_c('Row', {
    staticClass: "ivoice_four_part"
  }, [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [(this.langChange == 'en') ? _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/app_ivoice_en.png")
    }
  }) : (this.langChange == 'cn') ? _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/app_ivoice_sc.png")
    }
  }) : (this.langChange == 'tc') ? _c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/app_ivoice_tc.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('div', {
    staticClass: "ivoice_four_qrcode"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(" " + _vm._s(_vm.$t('ivoice_part4_tittle')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('ivoice_part4_content')) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "ivoice_four_qrcode_group"
  }, [_c('div', {
    staticClass: "ivoice_four_item"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/iapp.png"),
      "width": "150"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('download_iapp_qr')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "ivoice_four_item"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/iapp-best-travel-companion/id1210741206?mt=8"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ios@2x.png"),
      "width": "150"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/android"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/android@2x.png"),
      "width": "150"
    }
  })])])])])])], 1)], 1), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ivoice_city_wrap"
  }, [_c('img', {
    staticClass: "ivoice_city",
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_banner1_country.png"),
      "width": "150"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ivoice_two1_wrap"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/ivoice_banner2_phone@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f682d14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/iVoice/iVoice.vue
// module id = 811
// module chunks = 0